import React from 'react';
import styled, { css } from 'styled-components';
import { Tooltip as MuiTooltip, TooltipProps } from '@mui/material';

export const Tooltip = styled<React.FC<TooltipProps>>(
  ({ children, title, ...props }) => (
    <MuiTooltip title={title} {...props}>
      {children}
    </MuiTooltip>
  )
)`
  ${() => css`
    height: max-content;
  `}
`;

export const Span = styled('span')`
  ${({ theme }) => css`
    color: ${theme.palette.common.black};
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    display: block;
  `}
`;
